export const PROPERTIES_STATUS = {
  PRECAPTURED: {
    id: -5,
    name: "Precaptada",
    color: "#87CEEB"
  },
  INNEGOTIATION: {
    id: -4,
    name: "En Negociación",
    color: "#BA55D3"
  },
  INCONFLICT: {
    id: -3,
    name: "En Conflicto",
    color: "#FFA500"
  },
  DROPPED: {
    id: -2,
    name: "De Baja",
    color: "#FF6347"
  },
  PENDING: {
    id: -1,
    name: "Pendiente",
    color: "#FFFF00"
  },
  ACTIVE: {
    id: 0,
    name: "Disponible",
    color: "#8CC63F"
  },
  ERROR: {
    id: -11,
    name: "Error",
    color: "#D3D3D3"
  }
};

export const PROPERTIES_STATUS_FOR_SLUG = {
  Disponibles: PROPERTIES_STATUS.ACTIVE,
  Disponible: PROPERTIES_STATUS.ACTIVE,
  "En Negociación": PROPERTIES_STATUS.INNEGOTIATION,
  "En Conflicto": PROPERTIES_STATUS.INCONFLICT,
  "De Baja": PROPERTIES_STATUS.DROPPED,
  Pendientes: PROPERTIES_STATUS.PENDING,
  Pendiente: PROPERTIES_STATUS.PENDING,
  Precaptada: PROPERTIES_STATUS.PRECAPTURED,
  Error: PROPERTIES_STATUS.ERROR
};

export const PROPERTIES_STATUS_FOR_ID = {
  0: PROPERTIES_STATUS.ACTIVE,
  "-4": PROPERTIES_STATUS.INNEGOTIATION,
  "-3": PROPERTIES_STATUS.INCONFLICT,
  "-2": PROPERTIES_STATUS.DROPPED,
  "-1": PROPERTIES_STATUS.PENDING,
  "-5": PROPERTIES_STATUS.PRECAPTURED
};

export const PROPERTIES_STATUS_ARRAY = [
  PROPERTIES_STATUS.ACTIVE,
  PROPERTIES_STATUS.INNEGOTIATION,
  PROPERTIES_STATUS.INCONFLICT,
  PROPERTIES_STATUS.DROPPED,
  PROPERTIES_STATUS.PENDING,
  PROPERTIES_STATUS.PRECAPTURED
];

export type TPROPERTIES_STATUS_FOR_SLUG = keyof typeof PROPERTIES_STATUS_FOR_SLUG;
export type TPROPERTIES_STATUS_OBJECT = {
  id: number;
  name: string;
  color: string;
};
